import { getImageDataForCaseNumber } from '../api/imageReaderApi';
import {
  CASE_DOCUMENTS,
  RESET_CASE_DOCUMENTS,
  RESET_SELECTED_DOCUMENTS,
  SELECTED_CASE_DOCUMENTS,
  UPDATED_CASE_DOCUMENTS,
} from './actionTypes';

export const fetchDocumentsForCase = (caseNumber, documentTypes) => async (dispatch) => {
  let caseDocuments;
  try {
    caseDocuments = await getImageDataForCaseNumber(caseNumber, documentTypes);
  } catch (e) {
    caseDocuments = { data: [] };
  }
  dispatch({
    type: CASE_DOCUMENTS,
    caseDocuments,
  });
};

export const resetDocumentsForCase = () => (dispatch) => {
  dispatch({
    type: RESET_CASE_DOCUMENTS,
  });
};

export const updateSelectedCasePages =
  (documentType, orderOfSelectedPages, imageOrderSeq, selectedPages, selectedFileIndex, pageCount, selectAllFlag) =>
  (dispatch) => {
    dispatch({
      type: SELECTED_CASE_DOCUMENTS,
      documentType,
      orderOfSelectedPages,
      imageOrderSeq,
      selectedPages,
      selectedFileIndex,
      pageCount,
      selectAllFlag,
    });
  };

export const updateEditedPages = (documentType, selectedPages, pageListArray, imageToolKitData) => (dispatch) => {
  dispatch({
    type: UPDATED_CASE_DOCUMENTS,
    documentType,
    selectedPages,
    pageListArray,
    imageToolKitData,
  });
};

export const resetSelectedDocuments = (documentType) => (dispatch) => {
  dispatch({
    type: RESET_SELECTED_DOCUMENTS,
    documentType,
  });
};
